<template>
    <table  class="label">
        <tr style="height: 50px">
            <td colspan="8">
                <div>{{liga}}</div>
                <div>{{spiel.infos.bahn}}, {{spiel.infos.ort}}</div>
            </td>
        </tr>
        <tr style="height: 44px">
            <td colspan="1" rowspan="2" style="width: 9%"
                    class="green--text text--darken-1 header">DG {{durchgang}}</td>
            <td colspan="2" class="text-right pr-5 noBorderRight noBorderBottom">
                <div>Datum/Uhrzeit:</div><div>Verein:</div>
            </td>
            <td colspan="5" class="text-left noBorderBottom">
                <div>{{spiel.infos.datum}}, {{spiel.infos.uhrzeit}}</div>
                <div class="blue--text">{{spiel[teamType].teamName}}</div>
            </td>
        </tr>
        <tr style="height: 32px">
            <td colspan="2" class="text-right pr-5 noBorderRight">Spieler/in:</td>
            <td colspan="5" class="text-left red--text text--darken-1 header">
                {{spiel.partien[partie][teamType].spieler.name.substr(9)}}
            </td>
        </tr>
        <tr>
            <td>Bahn</td><td style="width: 12%">Volle</td><td style="width: 12%">Abr.</td>
            <td>Gesamt</td>
            <td style="width: 12%">FW</td><td>Semi</td><td>SaP</td><td>MaP</td>
        </tr>
        <tr>
            <td>{{bahnen[0]}}</td><td></td><td></td><td></td><td></td>
            <td rowspan="2"></td><td></td><td rowspan="5"></td>
        </tr>
        <tr><td>{{bahnen[1]}}</td><td></td><td></td><td></td><td></td><td></td></tr>
        <tr>
            <td>{{bahnen[2]}}</td><td></td><td></td><td></td><td></td>
            <td rowspan="2"></td><td></td>
        </tr>
        <tr><td>{{bahnen[3]}}</td><td></td><td></td><td></td><td></td><td></td></tr>
        <tr>
            <td>Gesamt</td><td></td><td></td><td></td><td></td>
            <td></td><td></td>
        </tr>
        <tr>
            <td colspan="4" class="signature text-left text-decoration-underline"
                style="vertical-align: top">Anmerkungen</td>
            <td colspan="4" class="signature grey--text text--lighten-1">
                Unterschrift Schiedsrichter</td>
        </tr>
        <tr class="grey--text text--lighten-1">
            <td colspan="4" class="signature">Unterschrift Spieler</td>
            <td colspan="4" class="signature">Unterschrift Kontrolle</td>
        </tr>
    </table>
</template>

<script>
    export default {
        name: "wurfzettel",
        props: ['spiel', 'teamType', 'partie', 'liga'],
        computed: {
            durchgang(){ return this.anzahlBahnen===6 ?
                            this.partie < 4 ? 1 : 2
                            :
                            Math.round(this.partie / 2);},
            anzahlBahnen(){
                let min = 100, max = 0;
                Object.keys(this.spiel.partien).forEach( (partieId) => {
                    const partie = this.spiel.partien[partieId];
                    if ( partie.heim.bahn < min ) { min = partie.heim.bahn }
                    if ( partie.gast.bahn < min ) { min = partie.gast.bahn }
                    if ( partie.heim.bahn > max ) { max = partie.heim.bahn }
                    if ( partie.gast.bahn > max ) { max = partie.gast.bahn }
                });
                return max - min + 1;
            }
        },
        data: () => ({
            bahnen: [],
        }),
        created(){
            this.setBahnen(this.spiel.partien[this.partie][this.teamType].bahn - this.spiel.partien['1'].heim.bahn + 1);
        },
        methods: {
            setBahnen(correctedBahn){
                this.bahnen = [];
                if ( this.anzahlBahnen === 6 ) {
                    switch (correctedBahn) {
                        case 1: this.bahnen = [1,2,4,3]; break;
                        case 2: this.bahnen = [2,1,3,4]; break;
                        case 3: this.bahnen = [3,4,6,5]; break;
                        case 4: this.bahnen = [4,3,5,6]; break;
                        case 5: this.bahnen = [5,6,2,1]; break;
                        case 6: this.bahnen = [6,5,1,2]; break;
                    }
                } else {
                    switch (correctedBahn) {
                        case 1: this.bahnen = [1,2,4,3]; break;
                        case 2: this.bahnen = [2,1,3,4]; break;
                        case 3: this.bahnen = [3,4,2,1]; break;
                        case 4: this.bahnen = [4,3,1,2]; break;
                    }
                }
                this.addStartBahn(this.spiel.partien['1'].heim.bahn - 1);
            },
            addStartBahn(startBahn){
                for ( let i = 0; i < this.bahnen.length; i++ ) {
                    this.bahnen[i] += startBahn;
                }
            },
        },
    }
</script>

<style scoped>
    table { width: 100%; border-spacing: 0;  border-top: solid 1px black;
        border-left: solid 1px black; text-align: center}/*border-collapse: collapse;*/
    td { border-bottom: solid 1px black; border-right: solid 1px black }
    .signature { font-size: 10px; height: 1.5cm }
    .label {font-size: 13px; font-weight: bold }
    .header {font-size: 15px; font-weight: bold; }
    .noBorderRight {border-right: none}
    .noBorderBottom {border-bottom: none}
</style>